import { Component, OnInit } from '@angular/core';
import { ServService } from '../../services/serv.service';
import { Router } from '@angular/router';
import { BikeService2 } from '../../services/bike2.service';
import { SmsService } from '../../services/sms.service';
import { MagasinService } from '../../services/magasin.service';
import { TasksService } from '../../services/tasks.service';
import { ApiService } from '../../services/api.service';

@Component({
    selector   : 'my-service',
    template: require('./service.component.html'),
    styles: [require('./service.component.scss')]
})

export class ServiceComponent implements OnInit {

    total: number = 0;
    listModal: any = {
        'toOver' : false,
        'toRestitute' : false,
        'delete' : false
    };
    compon: any;

    constructor(public apiService:ApiService, public servService: ServService, public router: Router, public bikeService2: BikeService2, public smsService:SmsService, public magasinService:MagasinService, public tasksService:TasksService) {
        this.compon = this;
    }

    ngOnInit(): void {
        this.total = 0;
    }

    reset(){
        this.calculateTotal();
    }

    toggle() {
        if (this.servService.current)
            this.servService.current = null;
    }

    deleteWork(work){
        let tmp = -1;
        for(let i = 0; i < this.servService.current.listWork.length; i++){
            if (work == this.servService.current.listWork[i]){
                tmp = i;
            }
        }
        if (tmp != -1) {
            this.servService.current.listWork.splice(tmp, 1);
            this.servService.current.modelChange();
        }
    }

    addWork(title, quantity, price) {
        this.servService.current.listWork.push({title: title, quantity: quantity, price: price});
        this.calculateTotal();
        this.checkForAddNewWork();
    }

    checkForAddNewWork() {
        this.servService.current.modelChange();
        this.calculateTotal();
        //let needNew = true;
        //this.servService.current.listWork.forEach(e=> {
        //    if (!(e.title && e.title != '')) {
                //needNew = false;
        //    } 
        //});
        //if (needNew)
            //this.addNewWork();
    }

    check(event, field){
        if (field == 'quantity'){
            if (event.target.valueAsNumber < 0 || event.target.valueAsNumber > 1000)
                event.target.className = 'error';
            else
                event.target.className = '';
        }
        if (field == 'title'){
            if (event.target.value.length < 2 || event.target.value.length > 42)
                event.target.className = 'error';
            else
                event.target.className = '';
        }
        if (field == 'price'){
            if (event.target.valueAsNumber < -100000 || event.target.valueAsNumber > 100000)
                event.target.className = 'error';
            else
                event.target.className = '';
        }
    }

    changeProcess(process:string){
        this.servService.current.validate();
        if (this.servService.current.errors)
            return ;
        if (process == 'over') {
            this.listModal.toOver = true;
        } else if (process == 'restitute') {
            this.listModal.toRestitute = true;
        }
    }

    changeInsurance(){
        this.servService.current.validate();
        if (this.servService.current.errors)
            return ;
        this.servService.current.isInsurance = !this.servService.current.isInsurance;
        this.servService.current.modelChange();
    }

    changeGuarantee(){
        this.servService.current.validate();
        if (this.servService.current.errors)
            return ;
        this.servService.current.isGuarantee = !this.servService.current.isGuarantee;
        this.servService.current.modelChange();
    }

    changeOver(){
        this.servService.current.validate();
        if (this.servService.current.errors)
            return ;
        this.servService.current.isOver = !this.servService.current.isOver;
        this.servService.current.modelChange();
    }

    changePaid(){
        this.servService.current.validate();
        if (this.servService.current.errors)
            return ;
        if (this.servService.current.paid)
            this.servService.current.paid = null;
        else
            this.servService.current.paid = new Date();
        this.servService.current.modelChange();
    }

    toOverWithoutSMS(){
        this.servService.current.process = 'over';
        this.servService.current.whenOver = new Date();
        this.servService.update(this.servService.current);
    }

    toOverWithSMS(){
        this.servService.current.process = 'over';
        this.servService.current.whenOver = new Date();
        this.servService.current.whenContacted = new Date();
        this.servService.update(this.servService.current);
        let mobile = '';
        if (this.servService.current.client.phone.mobile)
            mobile = this.servService.current.client.phone.mobile;
        this.smsService.open(this.servService.current.client.id, mobile, this.servService.current.client.lastName + ' ' + this.servService.current.client.firstName, 'service', this.servService.current.privateId);
    }

    toRestituteWithoutPaid(){
        this.servService.current.process = 'restitute';
        this.servService.current.whenRestitute = new Date();
        this.servService.update(this.servService.current);
    }

    toRestituteWithPaid(){
        this.servService.current.process = 'restitute';
        this.servService.current.whenRestitute = new Date();
        this.servService.current.paid = new Date();
        this.servService.update(this.servService.current);
    }

    toDelete(){
        this.servService.delete(this.servService.current);
        for (let i = 0; i < this.tasksService.list.length; i++){
            if (this.tasksService.list[i] == this.servService.current){
                this.tasksService.list.splice(i, 1);
            }
        }
        this.servService.current = null;
    }

    servicePdf(){
        this.servService.current.validate();
        if (this.servService.current.errors)
            return ;
        this.apiService.servicePdf(this.servService.current.privateId);
    }

    addNewWork() {
        this.servService.current.listWork.push({title: '', quantity: null, price: null});
    }

    calculeTotal(){
        let tmp = 0;
        this.servService.current.listWork.forEach(e=> {
            if (e.price && e.quantity)
                tmp += (e.price * e.quantity);
        });
        return tmp.toFixed(2);
    }

    calculateTotal() {
        let tmp = 0;
        this.servService.current.listWork.forEach(e=> {
            if (e.price && e.quantity)
                tmp += (e.price * e.quantity);
        });
        this.total = tmp;
    }

    goCustomer(id) {
        this.servService.current = null;
        this.router.navigate(['/customer/' + id]);
    }

    addBike(bike) {
        this.servService.current.bikeLinked = bike;
        this.servService.current.notBike = '';
        this.servService.current.modelChange();
    }

    deleteBike() {
        this.servService.current.bikeLinked = null;
        this.servService.current.notBike = '';
        this.servService.current.modelChange();
    }

    newBike() {
        this.bikeService2.addNew(this.servService.current.client.id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/service/service.component.ts